import api from "./axiosInstance";

export const getLobbyByGameMode = (gameModeId) => {
  return api.get(`/api/lobby/${gameModeId}`);
};
